<app-header [text]="'header.authorization'"></app-header>
<app-header-caption [text]="'header.authorization_caption'"></app-header-caption>

<button class="btn" (click)="redirectToSso()" [disabled]="isRedirecting">
  {{ 'sso.redirect_button' | translate }}
</button>

<div class="failed-login">{{ errorMessage }}</div>
